(function ($, Drupal, drupalSettings, window) {
  Drupal.behaviors.loadMarketingBlock = {
    attach: function (context) {
      const marketingBlock = $('[data-marketing-block]', context);
      const topicId = marketingBlock.data('marketing-block') || 0;
      const endpoint = `/${drupalSettings.path.pathPrefix}marketing-block-ajax-render/${topicId}`;

      function ajaxLoadMarketingBlock(wrapper) {
        $.ajax({
          type: 'GET',
          url: endpoint,
          dataType: 'html',
          success: function (response) {
            if (!response.length) {
              return;
            }

            wrapper.html(response);
            Drupal.attachBehaviors();
          },
          error: function () {
            // eslint-disable-next-line no-console
            console.log('An error occured trying to fetch the Marketing Block with ajax');
          }
        });
      }

      // Initialize ajax loading for the banner.
      marketingBlock.once('ajaxLoadMarketingBlock').each(function () {
        ajaxLoadMarketingBlock($(this));
      });
    }
  };
})(jQuery, Drupal, drupalSettings, window);
